import { render, staticRenderFns } from "./Tricks.vue?vue&type=template&id=5762d026&scoped=true&"
import script from "./Tricks.vue?vue&type=script&lang=js&"
export * from "./Tricks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5762d026",
  null
  
)

export default component.exports